<template>
    <div class="bgImg">
      
        <div class="flex pd16 m15">
            <img :src="userInfo.avatar" alt="" class="pic">
            <p class="user_account f_bold">{{userInfo.nickName}}</p>
        </div>

        <van-cell-group class="m15" :border="false" inset>  
                <van-cell icon="video-o" title="在线学习" is-link url="/courseList" title-class="title" />
                <van-cell icon="description" title="培训报名" is-link url="/signupList" title-class="title" />
                <van-cell icon="notes-o" title="我的培训" is-link url="/trainlist" title-class="title" />
                <van-cell icon="todo-list-o" title="我的考试" is-link url="/examlist" title-class="title" />
                <!-- <van-cell icon="todo-list-o" title="我的证件" is-link url="/filelist" title-class="title" /> -->
                <van-cell icon="records" title="模拟练习一" is-link url="/exercise" title-class="title" />
                <van-cell icon="records" title="模拟练习二" is-link url="/exercise2" title-class="title" />
                <van-cell icon="upgrade" title="我要上传" is-link url="/upload" title-class="title" />  
                <van-cell icon="setting-o" title="实名绑定" is-link url="/bindCard" title-class="title" />    
                <van-cell icon="question-o" title="答疑解惑" is-link url="/askList" title-class="title" />    
                <van-cell icon="user-o" title="会员单位" is-link url="/memberInfo" title-class="title" />    
        </van-cell-group>
    </div>
</template>

<script>
import { getUserInfo } from '../../api/custom';
export default {
  data() {
    return {
        userInfo:{
            avatar: "",
            nickName: ""
        }
    }

   },
   created(){
    this.getInfo()
   },
   methods: {
    getInfo(){
        getUserInfo().then(res=>{
            this.userInfo=res.data.info
        })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/online")
    },
  }

};
</script>

<style lang="less">
.user_account{
    font-size: 18px;
    margin-left:8px;
    color:#181818;

}
.nav1{
    font-size: 12px;
    color: #4a4a4a;
    margin: 8px 0;
}
.title{
    color: #181818;
    margin-left: 3px;
    font-size: 12px;
}
.round{
    border-radius: 5px;
    background: #ffffff;
    overflow: hidden;
}
.img_icon{
    width: 47px;
}
.pic{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}


</style>

